import React from 'react';
import { MainLayout } from 'COMPONENTS/Layout';
import IMG from 'ASSETS/robot.svg';

import './NotFoundPage.less';

const NotFoundPage = () => (
  <MainLayout>
    <div className="error-page">
      <div className="left-content">
        <IMG width="200" />
      </div>
      <div className="right-content">
        <span className="error-type">404</span>
        <span className="error-title">Page Not Found</span>
        <span className="error-desc">Click something different next time.</span>
      </div>
    </div>
  </MainLayout>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/ErrorPages/NotFound/NotFoundPage.js